// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__pLeX2","item":"style_item__PKfTp","itemArrow":"style_itemArrow__aZ-Xc","main":"style_main__j1+3+","contentItem":"style_contentItem__OU4KB"};